import React from "react";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default function ChatCloseButton() {
	const { chatViewStore } = useRootAppStore();

	const closeChatWindow = () => {
		chatViewStore.closeChat();
	};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/ChatCloseButton.tsx"}
		>
			<button
				onClick={closeChatWindow}
				className="chat__btn--close btn btn--square btn--square--xsml btn--icon btn--primary--inverted"
			>
				<i className="u-icon u-icon--tny u-icon--close u-color--text--primary" />
			</button>
		</ErrorBoundaryWithPropagation>
	);
}
